import * as Sentry from "@sentry/react";
import { auth } from "../auth/auth";

export function initSentry() {
  auth.onAuthStateChanged((user) => {
    if (!user) {
      Sentry.setUser(null);
    } else {
      const { context, info } = user;
      Sentry.setUser({
        email: info.email ?? undefined,
        // context can be null in some edge cases; avoid runtime errors when reading role
        role: context?.role,
      });
    }
  });
}
